import React from 'react'

const GitLabSVG = React.memo(() => {
  return (
    React.createElement('svg', {
      version: "1.1",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"   ,
      xmlns: "http://www.w3.org/2000/svg",}

      , React.createElement('g', { transform: "matrix(1.3333 0 0 -1.3333 0 745.33)"     ,}
        , React.createElement('g', { transform: "matrix(.0053314 0 0 .0053314 -6.6229 535.81)"     ,}
          , React.createElement('path', { d: "m2930.3 1240.2 621.99 1913.2h-1243.1l621.08-1913.2"   , fill: "#e33426",} )
          , React.createElement('path', {
            d: "m1438 3153.4-189.42-581.26c-17.13-52.78 1.37-111.04 46.61-143.94l1635.1-1188-1492.3 1913.2"    ,
            fill: "#f79818",}
          )
          , React.createElement('path', {
            d: "m1438 3153.4h871.2l-374.94 1152.2c-19.19 58.95-102.82 58.95-122.7 0l-373.56-1152.2"     ,
            fill: "#e33426",}
          )
          , React.createElement('path', {
            d: "m4423.5 3153.4 188.72-581.26c17.14-52.78-1.37-111.04-46.61-143.94l-1635.3-1188 1493.2 1913.2"    ,
            fill: "#f79818",}
          )
          , React.createElement('path', {
            d: "m4423.5 3153.4h-871.21l374.25 1152.2c19.2 58.95 102.82 58.95 122.7 0l374.26-1152.2"       ,
            fill: "#e33426",}
          )
          , React.createElement('path', { d: "m2930.3 1240.2 621.99 1913.2h871.21z"   , fill: "#f25923",} )
          , React.createElement('path', { d: "m2930.3 1240.2-1492.3 1913.2h871.2z"  , fill: "#f25923",} )
        )
      )
    )
  )
})

export default GitLabSVG
